module.exports = __webpack_public_path__ + "static/media/sort-down.1cf8c324.svg";